/**
 * Utility functions for inserting emojis into text input fields
 */

/**
 * Inserts an emoji at the current cursor position in a text input element
 * @param inputElement - The HTML input element
 * @param emoji - The emoji string to insert
 * @param currentValue - The current value of the input
 * @param onChange - Callback function to update the input value
 */
export const insertEmojiAtCursor = (
  inputElement: HTMLInputElement | HTMLTextAreaElement | null,
  emoji: string,
  currentValue: string,
  onChange: (newValue: string) => void
): void => {
  if (!inputElement) {
    // Fallback: append emoji to the end if we don't have input element reference
    onChange(currentValue + emoji);
    return;
  }

  const startPos = inputElement.selectionStart ?? currentValue.length;
  const endPos = inputElement.selectionEnd ?? currentValue.length;

  const newValue = currentValue.substring(0, startPos) + emoji + currentValue.substring(endPos);

  // Update the value
  onChange(newValue);

  // Set cursor position after the inserted emoji
  setTimeout(() => {
    const newCursorPos = startPos + emoji.length;
    inputElement.setSelectionRange(newCursorPos, newCursorPos);
    inputElement.focus();
  }, 0);
};
